import { render, staticRenderFns } from "./Bioanalyst.vue?vue&type=template&id=259f2fe5"
import script from "./Bioanalyst.vue?vue&type=script&lang=js"
export * from "./Bioanalyst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports